export const AXE_RULE_IDS = {
  COLOR_CONTRAST: 'color-contrast',
  CUSTOM_TITLE_TAG: 'custom-title-tag',
  ONLY_ONE_H1_HEADING: 'only-one-h1-heading',
  HEADING_ORDER: 'heading-order',
  HEADING_DATA: 'heading-data'
};
export const AXE_CHECK_IDS = {
  DOC_HAS_TITLE: 'doc-has-title',
  TITLE_DOESNT_CONTAIN_NEW_PAGE: 'title-doesnt-contain-new-page',
  TITLE_DOESNT_CONTAIN_COPY_OF: 'title-doesnt-contain-copy-of',
  TITLE_DOESNT_CONTAIN_COPY: 'title-doesnt-contain-copy',
  TITLE_VALID_LENGTH: 'title-valid-length',
  ONLY_ONE_H1_HEADING: 'only-one-h1-heading',
  HEADING_DATA: 'heading-data'
};
export const DEFAULT_PAGE_TITLES = {
  cs: {
    copyOf: 'kopie',
    newPage: 'nová stránka'
  },
  da: {
    copyOf: 'kopi af',
    newPage: 'ny side'
  },
  de: {
    copyOf: 'kopie von',
    newPage: 'neue seite'
  },
  en: {
    copy: '(copy)',
    copyOf: 'copy of',
    newPage: 'new page'
  },
  es: {
    copyOf: 'copia de',
    newPage: 'nueva página'
  },
  fr: {
    copyOf: 'copie de',
    newPage: 'nouvelle page'
  },
  id: {
    copyOf: 'salinan dari',
    newPage: 'halaman baru'
  },
  it: {
    copyOf: 'copia di',
    newPage: 'nuova pagina'
  },
  ja: {
    copyOf: 'のコピー',
    newPage: '新しいページ'
  },
  ko: {
    copyOf: '복제',
    newPage: '새 페이지'
  },
  nl: {
    copyOf: 'kopie van',
    newPage: 'nieuwe pagina'
  },
  no: {
    copyOf: 'kopi av',
    newPage: 'ny side'
  },
  pl: {
    copyOf: 'kopia',
    newPage: 'nowa strona'
  },
  pt: {
    copyOf: 'cópia de',
    newPage: 'nova página'
  },
  ru: {
    copyOf: 'копия стр.',
    newPage: 'новая страница'
  },
  sv: {
    copyOf: 'kopia av',
    newPage: 'ny sida'
  },
  th: {
    copyOf: 'สำเนาของ',
    newPage: 'เพจใหม่'
  },
  tr: {
    copyOf: 'kopyası',
    newPage: 'yeni sayfa'
  },
  uk: {
    copyOf: 'копія',
    newPage: 'нова сторінка'
  },
  vi: {
    copyOf: 'bản sao của',
    newPage: 'trang mới'
  },
  zh: {
    copyOf: '的副本',
    newPage: '新網頁'
  }
};
//# sourceMappingURL=constants.js.map